module.exports = __webpack_public_path__ + "static/media/icon-arrow.a14bf13f.svg";